'use strict'
import utilsHelper from '@/helpers/utils'

const Utils = {};

// eslint-disable-next-line no-unused-vars
Utils.install = function(Vue, options) {
  Utils.isJSON = function (str) {
    return utilsHelper.isJSON(str);
  }
  Utils.saveAsImage = function (chartContainer, type = 'png', fileName = 'file') {
    utilsHelper.saveAsImage(chartContainer, type, fileName)
  }
  Utils.saveAsFile = function (blob, fileName) {
    utilsHelper.saveAsFile(blob, fileName)
  }
  Utils.dataURLtoFile = function (dataUrl, fileName) {
    return utilsHelper.dataURLtoFile(dataUrl, fileName);
  }

  if (!Vue.$utils) {
    Vue.$utils = Utils
    Object.defineProperties(Vue.prototype, {
      $utils: {
        get () {
          return Utils
        }
      }
    })
  }
}

export default Utils
